import { createInertiaApp } from "@inertiajs/react";
import { createElement, ReactNode } from "react";
import { createRoot } from "react-dom/client";
import Layout from "../components/Layout";
import Application from "../components/Application";

createInertiaApp({
  title: title => (title ? `${title} - OPEN COURT` : "OPEN COURT"),

  resolve: name => {
    const pages = import.meta.glob("../pages/**/*.tsx", {
      eager: true,
    });
    let page = pages[`../pages/${name}.tsx`];
    if (!page) {
      console.error(`Missing Inertia page component: '${name}.tsx'`);
    }
    page.default.layout ||= page => createElement(Layout, null, page);

    return page;
  },

  setup({ el, App, props }) {
    if (el) {
      const WrappedApp = createElement(Application, null, createElement(App, props));
      createRoot(el).render(WrappedApp);
    } else {
      console.error(
        "Missing root element.\n\n" +
          "If you see this error, it probably means you load Inertia.js on non-Inertia pages.\n" +
          'Consider moving <%= vite_typescript_tag "inertia" %> to the Inertia-specific layout instead.'
      );
    }
  },
});
